import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { baseUrl } from '@/shared/constant';

interface MetaDataTagsProps {
  title: string;
  description: string;
  noIndex?: boolean;
}

const dnsPrefetchLinks = [
  "https://app-sj28.marketo.com",
  "https://app-sj31.marketo.com",
  "https://assets.adobedtm.com",
  "https://bootstrap.api.drift.com",
  "https://driftt.imgix.net",
  "https://embeds.driftcdn.com",
  "https://event.api.drift.com",
  "https://flow.api.drift.com",
  "https://js.driftt.com",
  "https://metrics.api.drift.com",
  "https://munchkin.marketo.net",
  "https://s.go-mpulse.net",
  "https://targeting.api.drift.com",
  "https://www.google-analytics.com",
  "https://www.googletagmanager.com",
];

const MetaDataTags: React.FC<MetaDataTagsProps> = ({ title, description, noIndex }) => {
  const location = useLocation();
  const canonicalUrl = `${baseUrl}${location.pathname}`;

  return (
    <Helmet>
      {/* DNS Prefetch */}
      {dnsPrefetchLinks.map(link => (
        <link rel="dns-prefetch" href={link} key={link} />
      ))}      
      <title>{title}</title>
      <meta name="description" content={description} />
      {noIndex && <meta name="robots" content="noindex" />}
      {/* Canonical Tag */}
      <link rel="canonical" href={canonicalUrl} />
      {/* Open Graph / Facebook */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="article" />
      <meta property="og:url" content={canonicalUrl} />
    </Helmet>
  );
};

export default MetaDataTags;
